import { Component, OnInit } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-drafts',
  templateUrl: './drafts.page.html',
  styleUrls: ['./drafts.page.scss'],
})
export class DraftsPage implements OnInit {
  drafts: any[] = [];
  finished_loading = false;

  constructor(private apiService: ApiService, public globalService: GlobalService, private modalController: ModalController, private alertController: AlertController) { }

  ngOnInit() {
    this.Get();
  }

  async Get() {
    this.finished_loading = false;
    let data: any = await this.apiService.get('email_drafts');
    this.drafts = data.data || [];
    // Parsed once here (rather than in the template) so a bad/legacy draft's JSON only needs to
    // be handled in one place - see BuildRecipientsSummary for the to_list/to_list_companies shape.
    this.drafts.forEach((draft: any) => draft.recipients_summary = this.BuildRecipientsSummary(draft));
    this.finished_loading = true;
  }

  // Draft `data` is { secure_email_data: {..., to_list: [contacts]}, to_list_companies: [companies] } -
  // the same snapshot shape create.page.ts's SaveDraft writes. Falls back to '' (hidden in the
  // template) for a draft saved before any recipient was picked, or one that fails to parse.
  private BuildRecipientsSummary(draft: any): string {
    if (!draft?.data) return '';
    try {
      const snapshot = JSON.parse(draft.data);
      const names: string[] = [
        ...((snapshot.secure_email_data?.to_list || []).map((c: any) => c.display_name || c.email).filter(Boolean)),
        ...((snapshot.to_list_companies || []).map((c: any) => c.name).filter(Boolean))
      ];
      return names.join(', ');
    } catch (e) {
      return '';
    }
  }

  FormatDraftDate(date: string): string {
    if (!date) return '';
    return dayjs(this.globalService.DateToUTCFormat(date)).format('MMM D, YYYY h:mm A');
  }

  // Fetches the full draft (including its data blob) and hands it back to the caller, which is
  // responsible for opening the compose modal with it - keeps this page a plain list+dismiss,
  // matching how the rest of this modal's siblings (Templates, Signature) work.
  async OpenDraft(draft: any) {
    let data: any = await this.apiService.get(`email_drafts/${draft.guid}`);
    if (data.success && data.data && data.data[0]) {
      this.modalController.dismiss(data.data[0]);
    } else {
      this.globalService.presentToastMessage('Failed to load draft', false);
    }
  }

  async DeleteDraft(draft: any, event: Event) {
    event.stopPropagation();
    const alert = await this.alertController.create({
      header: 'Delete Draft',
      message: `Are you sure you want to delete the draft "${draft.subject || '(No Subject)'}"? This cannot be undone.`,
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        {
          text: 'Delete',
          role: 'destructive',
          handler: async () => {
            let data: any = await this.apiService.delete(`email_drafts/${draft.guid}`, null);
            this.globalService.presentToastMessage(data.message, data.success);
            if (data.success) this.globalService.RemoveFromArray(this.drafts, draft.guid);
          }
        }
      ]
    });
    await alert.present();
  }

  async Close() {
    this.modalController.dismiss(null);
  }
}
